import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import headerMine from '@/layout/header-mine'

Vue.use(Router)
const scrollBehavior = function (to, from, savedPosition) {
  if (to.hash) {
    return {
      // 通过 to.hash 的值來找到对应的元素
      selector: to.hash
    }
  } else {
    return {
      y: 0
    }
  }
}
export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'index',
      //   component: () => import('@/views/index')
      component: () => import('@/views/index/indexNew')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login')
    },
    {
      path: '/destinationHome',
      name: 'destinationHome',
      component: () => import('@/views/home/destinationHome')
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: () => import('@/views/home/productDetail')
    },
    {
      path: '/destinationDetail',
      name: 'destinationDetail',
      component: () => import('@/views/home/destinationDetail')
    },
    {
      path: '/admissionTicket',
      name: 'admissionTicket',
      component: () => import('@/views/home/admissionTicket')
    },
    //  订单填写
    {
      path: '/orderWrite',
      name: 'orderWrite',
      component: () => import('@/views/home/orderWrite')
    },
    // 支付订单
    {
      path: '/payOrder',
      name: 'payOrder',
      component: () => import('@/views/home/payOrder')
    },
    //  支付成功
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import('@/views/home/paySuccess')
    },
    //  出票成功
    {
      path: '/ticketSuccess',
      name: 'ticketSuccess',
      component: () => import('@/views/home/ticketSuccess')
    },
    //  我的首页
    {
      path: '/mine',
      name: 'mine',
      redirect: '/mine/index',
      component: headerMine,
      children: [
        // 首页
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/mine/mine')
        },
        // 优惠卷
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import('@/views/mine/coupon')
        },
        // 我的收藏
        {
          path: 'myCollection',
          name: 'myCollection',
          component: () => import('@/views/mine/myCollection')
        },
        // 站内消息
        {
          path: 'stationNews',
          name: 'stationNews',
          component: () => import('@/views/mine/stationNews')
        },
        // 我的订单
        {
          path: 'myOrder',
          name: 'myOrder',
          component: () => import('@/views/mine/myOrder')
        },
        // 我的积分
        {
          path: 'myIntegral',
          name: 'myIntegral',
          component: () => import('@/views/mine/myIntegral')
        },
        // 晒图评价
        {
          path: 'pictureEvaluate',
          name: 'pictureEvaluate',
          component: () => import('@/views/mine/pictureEvaluate')
        },
        // 消息
        {
          path: 'bigNews',
          name: 'bigNews',
          component: () => import('@/views/mine/bigNews')
        },
        // 我的信息
        {
          path: 'myInformation',
          name: 'myInformation',
          component: () => import('@/views/mine/myInformation')
        },
        // 我的头像
        {
          path: 'myPhoto',
          name: 'myPhoto',
          component: () => import('@/views/mine/myPhoto')
        },
        // 绑定设置
        {
          path: 'bindingSeting',
          name: 'bindingSeting',
          component: () => import('@/views/mine/bindingSeting')
        },
        // 账户安全
        {
          path: 'accountSecurity',
          name: 'accountSecurity',
          component: () => import('@/views/mine/accountSecurity')
        },
        // 修改号码
        {
          path: 'modifyNumber',
          name: 'modifyNumber',
          component: () => import('@/views/mine/modifyNumber')
        }
      ]
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/login/register')
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('@/views/login/forget')
    }, // 搜索
    {
      path: '/searchProduct',
      name: 'searchProduct',
      component: () => import('@/views/home/searchProduct')
    }, // 社区
    {
      path: '/community',
      name: 'community',
      component: () => import('@/views/home/community')
    }, // 社区详情
    {
      path: '/communityDetail',
      name: 'communityDetail',
      component: () => import('@/views/home/communityDetail')
    }, // 景区详情
    {
      path: '/scenicSpotDetail',
      name: 'scenicSpotDetail',
      component: () => import('@/views/home/scenicSpotDetail')
    },
    {
      path: '/spotdetail',
      name: 'spotdetail',
      component: () => import('@/views/home/scenicSpotDetail')
    },
    {
      path: '/single/n666',
      name: 'n666',
      component: () => import('@/views/login/n666')
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      meta: {
        title: '',
        hidden: true
      }
    },
    {
      path: '*',
      redirect: '/404',
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js